import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../../constants/Colors";
import { allImages } from "../../../assets";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1000px",
  margin: "auto",
  padding: "16px",

  "& .lpl_rs_pr": {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_rs_sr": {
    fontSize: "1.8rem",
    fontWeight: 600,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
}));

const loginSteps = [
  {
    step: 1,
    description: "Check all review and rating.",
  },
  {
    step: 2,
    description:
      "If price and service full fill your demand then just click booking.",
  },
  {
    step: 3,
    description:
      "Also you can select packages and subscription based services.",
  },
];

function Bbclients() {
  const renderSteps = () => {
    return loginSteps?.map((val, ind) => {
      return (
        <Box mt={3} key={ind}>
          <Typography variant="h1" className="lpl_rs_sr">
            Step {val.step}
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
          >
            {val.description}
          </Typography>
        </Box>
      );
    });
  };
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Grid container spacing={{ xs: 2, md: 4 }} flexWrap={"wrap-reverse"}>
        <Grid item xs={12} md={6}>
          <Typography variant="h1" className="lpl_rs_pr">
            2- B2B Profile
          </Typography>
          <Typography variant="h1" className="lpl_rs_pr">
            Best way to see spa & Salon
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
          >
            "Our app's application show client all details like
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
            lineHeight={"normal"}
          >
            1- Location
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
            lineHeight={"normal"}
          >
            2- Services
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
            lineHeight={"normal"}
          >
            3- Rating
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
            lineHeight={"normal"}
          >
            4- Team members"
          </Typography>
          <Typography
            variant="body1"
            color={"primary.main"}
            fontStyle={"italic"}
          >
            Download application form app store & play store.
          </Typography>
          {renderSteps()}
        </Grid>
        <Grid item xs={12} md={6}>
          <img src={allImages.landingMobileBb2} alt={"image"} width={"100%"} />
        </Grid>
      </Grid>
    </MainView>
  );
}

export default Bbclients;
